import { Injectable } from '@angular/core';
import { Observable, ReplaySubject } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class LoadingService {
  public isLoading: boolean;
  public loading$: Observable<boolean>;

  private loadingSource = new ReplaySubject<boolean>();

  public constructor() {
    this.loading$ = this.loadingSource.asObservable();
  }

  /**
   * Toggle the loader variable status
   *
   * @param {boolean} loadingStatus
   */
  public toggleLoader(loadingStatus: boolean): void {
    this.isLoading = loadingStatus;
    this.loadingSource.next(loadingStatus);
  }
}
